import { BoostSkewFilterState } from './store/boostSkew.types';

type hashFunctionType = (isBoostSkewed: BoostSkewFilterState['isBoostSkewed']) => string;

export const boostSkewFilterHash: hashFunctionType = (isBoostSkewed) => String(isBoostSkewed);
